import { TransformTable } from '@/components/table/TransformTable/TransformTable';

export default function Transforms() {
  return <TransformTable />;
}
